'use strict';

var MarketWizardDirective = function MarketWizardDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/market-wizard.html'),
    controller: 'MarketWizardController'
  };
};
MarketWizardDirective.$inject = [];
module.exports = MarketWizardDirective;